import { obterCentroCustoAsync } from "../../services/centroCustoService";

const atualizarCentrosCusto = async ({ commit }) => {
    const centrosCusto = await obterCentroCustoAsync();
    commit('atualizarCentrosCusto', centrosCusto);
}

const atualizarCentroCusto = ({ commit }, centroCusto) => {
    commit('atualizarCentroCusto', centroCusto);
}

const addCentroCusto = ({ commit }, centroCusto) => {
    commit('addCentroCusto', centroCusto);
}

const updateCentroCusto = ({ commit }, centroCusto) => {
    commit('updateCentroCusto', centroCusto);
}

export default {
    atualizarCentrosCusto,
    atualizarCentroCusto,
    addCentroCusto,
    updateCentroCusto
}
